export default "__VITE_ASSET__0rdJCrY$__"